import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Footer.css";
import { getConsultationPath } from "../../utils/consultationLink";
import { WEB_LEAD_MODULES } from "../../constants/webLeadModules";

const FOOTER_CONSULTATION_LINKS = [
  { label: "Investment Strategy", module: WEB_LEAD_MODULES.WEALTH_INV },
  { label: "Wealth Management", module: WEB_LEAD_MODULES.WEALTH_WM },
  { label: "Growth & Allocation", module: WEB_LEAD_MODULES.WEALTH_GA },
  // { label: "MCX", module: WEB_LEAD_MODULES.WEALTH_MCX },
];

const Footer = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const isHome =
    location.pathname === "/" || location.pathname.startsWith("/v");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.pageYOffset > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  /* Smooth scroll same as navbar */
  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);

    if (!isHome) {
      navigate("/");
      setTimeout(() => {
        const target = document.querySelector(href);
        if (target)
          target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    } else {
      const target = document.querySelector(href);
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleAboutClick = (e) => {
    e.preventDefault();
    navigate("/about");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="wc-ui-footer">
      <div className="wc-ui-footer-container">
        {/* Brand */}
        <div className="wc-ui-footer-col wc-ui-footer-col-brand">
          <h3 className="wc-ui-footer-brand-heading">Wealth Compounders</h3>

          <p className="wc-ui-footer-brand-text">
            Your trusted partner in building lasting wealth. We combine
            expertise, innovation, and personalized service to help you achieve
            your financial goals.
          </p>

          <div className="wc-ui-footer-socials">
            <a
              className="wc-ui-footer-social-btn"
              aria-label="LinkedIn"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fa-brands fa-linkedin-in"></i>
            </a>

            <a
              className="wc-ui-footer-social-btn"
              aria-label="Twitter"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fa-brands fa-twitter"></i>
            </a>

            <a
              className="wc-ui-footer-social-btn"
              aria-label="Facebook"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fa-brands fa-facebook-f"></i>
            </a>

            <a
              className="wc-ui-footer-social-btn"
              aria-label="Instagram"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fa-brands fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* SERVICES (Consultation CTA) */}
        <div className="wc-ui-footer-col">
          <h4 className="wc-ui-footer-col-title">Consultation</h4>

          <ul className="wc-ui-footer-link-list">
            {FOOTER_CONSULTATION_LINKS.map(({ label, module }) => (
              <li key={label}>
                <a
                  href={getConsultationPath(module)}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(getConsultationPath(module));
                    window.scrollTo(0, 0);
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* COMPANY */}
        <div className="wc-ui-footer-col">
          <h4 className="wc-ui-footer-col-title">Company</h4>

          <ul className="wc-ui-footer-link-list">
            <li>
              <a href="/about" onClick={handleAboutClick}>
                About Us
              </a>
            </li>

            <li>
              <a
                href="#wc-ui-testimony"
                onClick={(e) => handleNavClick(e, "#wc-ui-testimony")}
              >
                Testimonials
              </a>
            </li>

            <li>
              <a
                href="/wealth"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/wealth");
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
              >
                Products
              </a>
            </li>

            <li>
              <a
                href="/services"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/services");
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="/calculators"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/calculators");
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
              >
                Calculators
              </a>
            </li>
          </ul>
        </div>

        {/* LEGAL */}
        <div className="wc-ui-footer-col">
          <h4 className="wc-ui-footer-col-title">Legal</h4>

          <ul className="wc-ui-footer-link-list">
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>

            <li>
              <a href="/terms">Terms & Conditions</a>
            </li>

            <li>
              <a href="/disclaimer">Disclaimers</a>
            </li>

            <li>
              <a href="/regulatory-information">Regulatory Information</a>
            </li>
          </ul>
        </div>

        {/* CONTACT (Consultation CTA) */}
        {/* <div className="wc-ui-footer-col">
          <h4 className="wc-ui-footer-col-title">Contact</h4>

          <button
            className="wcs-btn-primary"
            onClick={() => navigate("/consultation")}
          >
            Schedule Consultation
          </button>
        </div>*/}
        {/* CONTACT (Consultation CTA) */}
        <div className="wc-ui-footer-col">
          <h4 className="wc-ui-footer-col-title">Contact</h4>

          <ul className="wc-ui-footer-link-list">
            <li>
              <a
                href={getConsultationPath(WEB_LEAD_MODULES.FOOTER)}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(getConsultationPath(WEB_LEAD_MODULES.FOOTER));
                  window.scrollTo(0, 0);
                }}
              >
                Schedule Consultation
              </a>
            </li>
            {["Contact Us", "Support", "General Inquiry"].map((service) => (
              <li key={service}>
                <a
                  href={service === "Support" ? "/support" : "/contact"}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(service === "Support" ? "/support" : "/contact");
                    window.scrollTo(0, 0);
                  }}
                >
                  {service}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="wc-ui-footer-bottom">
        <div className="wc-ui-footer-divider"></div>

        <p className="wc-ui-footer-copy">
          © 2026 Wealth Compounders. All rights reserved. |{" "}
          <span>Registered Investment Advisor</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
